import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, HostBinding} from '@angular/core';
import * as _ from 'lodash';
@Component({
    selector: 'app-tab-panel',
    templateUrl: './tab-panel.component.html',
    styleUrls: ['./tab-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabPanelComponent implements OnInit, OnChanges {
  public currentTabName = '';
  @Input() isMobile = false;
  @Input() keepLabelsOnNarrow = false;
  @Input() tabs: {name: string, id: string, hidden?: boolean, icon?: string}[] = [];
  @Input() hideTabs = false;
  @Output() close= new EventEmitter();
  @Output() tabChanged = new EventEmitter();
  @Output() scrollUpdate = new EventEmitter();
  public scrollTop = 0;
  @HostBinding('class.tab-panel-host_keep-labels-on-narrow') get keepLabelsOnNarrowClass() {
    return this.keepLabelsOnNarrow;
  }
  constructor() { }

  ngOnInit() {
    this.tabs = this.tabs.filter(tab => !tab.hidden);
    if (this.tabs.length > 0) {
      this.currentTabName = this.tabs[0].id;
    }
  }

  ngOnChanges() {
    const currentTab = this.tabs.find(t => t.id === this.currentTabName) || this.tabs[0];
    if (currentTab.hidden) {
      const newTab = this.tabs.find(t => !t.hidden);
      this.activatedTab(newTab.id);
    }
  }

  activatedTab(name: string): void {
    this.tabChanged.emit(name);
    this.currentTabName = name;
  }

  onClose(action): void {
    this.close.emit({close: true});
  }

  // tslint:disable-next-line:member-ordering
  onScroll = _.throttle((event) => {
    if (event) {
      this.scrollTop = event.target.scrollTop;
      this.scrollUpdate.next(this.scrollTop);
    }
  }, 100);

}
